type Props = {
  soldOut?: boolean;
  inPossession?: boolean;
  className?: string;
};

export function ItemStatusTag({ soldOut, inPossession, className = "absolute left-3 top-3 z-10" }: Props) {
  if (soldOut) {
    return (
      <div
        className={`${className} rounded-sm bg-slate-500/70 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-white`}
      >
        Sold out
      </div>
    );
  }
  if (inPossession === false) {
    return (
      <div
        className={`${className} rounded-sm bg-amber-600/80 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-white`}
      >
        On Order
      </div>
    );
  }
  return null;
}
